import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Text } from '@fragments';
import { GRANULARITY_TYPES } from '../../../enums/granularityTypes';
import './styles.scss';

export default function GranularityPopperContent({ value, onApply }) {
    const { t } = useTranslation('dashboard');
    const [amount, setAmount] = useState(String(value?.amount ?? 1));
    const [type, setType] = useState(value?.type ?? 'day');

    const numericAmount = Math.max(1, parseInt(amount, 10) || 1);

    function handleApply() {
        onApply({ type, amount: numericAmount });
    }

    return (
        <div className="insights-granularity-popper">
            <Text.span contrast={5} className="insights-granularity-popper__label">
                {t('insights.granularity.popper.every')}
            </Text.span>

            <div className="insights-granularity-popper__row">
                <div className="insights-granularity-popper__amount">
                    <Input.Integer
                        value={amount}
                        onInput={setAmount}
                        placeholder="1"
                        max={3}
                    />
                </div>
                <div className="insights-granularity-popper__type">
                    <Input.Select
                        value={type}
                        onInput={setType}
                        placeholder={t('insights.granularity.popper.typePlaceholder')}
                        options={GRANULARITY_TYPES.map(g => ({
                            label: t(numericAmount > 1 ? g.pluralKey : g.labelKey),
                            value: g.id,
                        }))}
                    />
                </div>
            </div>

            <Button
                text={t('common:actions.apply')}
                color="primary"
                size="small"
                fullWidth
                onClick={handleApply}
                className="insights-granularity-popper__apply"
            />
        </div>
    );
}
